import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer, MainContainer } from '../../ui';
import { ArbiWinHeader, ArbiWinFooter } from '../../ui';
import ForgotPasswordForm from './ForgotPasswordForm';

/**
 * ForgotPasswordPage component - Page for requesting password reset
 * @returns {JSX.Element} ForgotPasswordPage component
 */
const ForgotPasswordPage = function ForgotPasswordPage() {
  const navigate = useNavigate();
  
  return (
    <PageContainer>
      <ArbiWinHeader 
        isAuthenticated={false}
        onLogin={() => navigate('/login')}
        onRegister={() => navigate('/register')}
        onHomeClick={() => navigate('/')}
      />
      <MainContainer>
        <div style={{ maxWidth: 480, margin: '0 auto', padding: 'var(--spacing-8) var(--spacing-4)' }}>
          <ForgotPasswordForm 
            onBackToLogin={() => navigate('/login')}
          />
        </div>
      </MainContainer>
      <ArbiWinFooter />
    </PageContainer>
  );
};

export default ForgotPasswordPage;
